import { render } from "./TheDeviceList.vue?vue&type=template&id=1dc20740"
import script from "./TheDeviceList.vue?vue&type=script&lang=js"
export * from "./TheDeviceList.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__